import React, { useState, forwardRef } from "react";
import { Link } from "react-router-dom";
import "../multiplierMaster/MultiplierMaster.scss";
import "react-datepicker/dist/react-datepicker.css";
import { NotFound } from "../../components/common/NotFound";
import DeleteModal from "../../components/common/DeleteModal";

const MultiplierMasterList = () => {
  const [baseColumns] = useState([
    {
      heading: "Customer Name",
      value: "CustomerName",
      sortable: true,
      title: "CustomerName",
      dataIndex: "CustomerName",
      key: "CustomerName",
    },
    {
      heading: "Email",
      value: "Email",
      sortable: true,
      title: "Email",
      dataIndex: "Email",
      key: "Email",
    },
    {
      heading: "Assigned Engineer",
      value: "AssignedEngineer",
      sortable: true,
      title: "AssignedEngineer",
      dataIndex: "AssignedEngineer",
      key: "AssignedEngineer",
    },
    {
      heading: "Credit Limit",
      value: "Creditlimit",
      sortable: true,
      title: "Creditlimit",
      dataIndex: "Creditlimit",
      key: "Creditlimit",
    },
    {
      heading: "Country",
      value: "Country",
      sortable: true,
      title: "Country",
      dataIndex: "Country",
      key: "Country",
    },
    {
      heading: "Status",
      value: "status",
      sortable: true,
      title: "status",
      dataIndex: "status",
      key: "status",
    },
  ]);

  const [selected, setSelected] = useState([]);

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData == true) {
      setSelected((oldData) => [...oldData, e.target.value]);
      // let value = baseColumns.filter((item) => !selected.includes(item.dataIndex))
      // setFilterColumn(value);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };
  return (
    <div className="container-fluid multiplier-master-list-sec pl-5 pr-5">
      {/* <!-- search-area-sec starts --> */}
      <div className="card mt-3">
        <div className="card-body">
          <section className="search-area-sec">
            <div className="row">
              <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 my-auto">
                <div className="mob-text-align">
                  <p>
                    Multiplier Master - <span>100 Results Found</span>
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div className="d-flex">
                  <div className="input-group text-align">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                    />
                    <div className="input-group-append">
                      <button className="btn" type="button">
                        <i className="fas fa-times"></i>
                      </button>
                      <button className="btn" type="button">
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <div className="text-align">
                    <button className="btn refresh-btn" type="button">
                      <i class="fas fa-redo"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- search-area-sec ends --> */}

          {/* <!-- table-sec starts --> */}
          <section className="table-sec mt-3">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="table-responsive">
                  <table className="table table-striped table-borderless">
                    <thead>
                      <tr>
                        <th scope="col" className="sort-icon">
                          Distributor Name / Company Name
                        </th>
                        <th scope="col">Role</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Khalid Manufacturing Company</td>
                        <td>Sales Coordinator</td>
                        <td>
                          <span>
                            <i className="far fa-edit mr-2" title="Edit"></i>
                          </span>
                          <span>
                            <i className="far fa-trash-alt" title="View"></i>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Khalid Manufacturing Company</td>
                        <td>Sales Coordinator</td>
                        <td>
                          <span>
                            <i className="far fa-edit mr-2" title="Edit"></i>
                          </span>
                          <span>
                            <i className="far fa-trash-alt" title="View"></i>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- table-sec ends --> */}
          {/* pagination-sec start */}
          <section className="pagination-sec mt-3">
            <div className="row">
              <div className="col-md-12">
                <div className="pagination-d-flex">
                  <div className="d-flex justify-content-end align-items-baseline">
                    <p className="mr-2">Show</p>
                    <select className="form-control">
                      <option selected value="10">
                        1
                      </option>
                      <option value="2">2</option>
                    </select>
                  </div>
                  <nav aria-label="Page navigation example" className="ml-4">
                    <ul className="pagination">
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link active" href="#">
                          1
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          2
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          3
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </section>
          {/* pagination-sec end */}
        </div>
      </div>

      {/*  <!-- filter modal--> */}

      {/* <!-- deleteModal --> */}
      <DeleteModal />

      {/*  <!-- NotFound --> */}
      <NotFound />
    </div>
  );
};
export default MultiplierMasterList;
